import { createSelector } from "reselect";

import { displayCacheSelectors } from "../../../modules/display";

/**
 * @param {TimelineRecord} state
 * @param {number} itemCardViewTextWidth
 */
export default createSelector(
  // input
  displayCacheSelectors.getDisplayItemsById,
  // output
  displayItems => displayItems.toList()
);
